export default __webpack_public_path__ + "static/media/chat.930f0321.svg";